import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';

export const store = configureStore({ reducer: rootReducer });

export type State = ReturnType<typeof store.getState>;
